/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { riskItemEntrySchema } from './riskItemEntrySchema';

export const riskSubsetSchema = z.object({
  count: z.int(),
  get items() {
    return z.array(riskItemEntrySchema);
  },
});
